{
  "access": {
    "denied": "Access Denied",
    "noPermission": "You don't have permission to view this page"
  },
  "navigation": {
    "unsavedChanges": {
      "title": "Unsaved changes",
      "message": "You have unsaved changes. Are you sure you want to leave this page?",
      "stay": "Stay",
      "leave": "Leave page",
      "discardMessage": "You have unsaved changes. Continue and lose them?",
      "discard": "Continue without saving"
    }
  },
  "action": {
    "expand": "Expand",
    "collapse": "Collapse",
    "create": "Create",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "back": "Back",
    "start": "Start",
    "import": "Import",
    "export": "Export",
    "analyze": "Analyze",
    "done": "Done",
    "selectFile": "Select file",
    "selectFileToImport": "Select file to import",
    "restart": "Restart",
    "stop": "Stop",
    "logs": "Logs",
    "detail": "Detail",
    "backHome": "To main",
    "action": "Action",
    "cancel": "Cancel",
    "close": "Close",
    "ok": "Save",
    "save": "Save",
    "saveAs": "Save as",
    "saveAsNew": "Save as new",
    "rename": "Rename",
    "upload": "Upload",
    "load": "Load",
    "send": "Send",
    "copy": "Copy",
    "paste": "Paste",
    "okAndAdd": "Save and add",
    "delete": "Delete",
    "restore ": "Restore",
    "add": "Add",
    "update": "Update",
    "retry": "retry",
    "clone": "Clone",
    "show": "Show",
    "open": "Open",
    "edit": "Edit",
    "play": "Start",
    "editPassword": "Edit password",
    "groupBy": "Group by",
    "select": "Select",
    "apply": "Apply",
    "clear": "Clear",
    "clearAll": "Clear all",
    "reset": "Reset",
    "allow": "Allow",
    "disallow": "Disallow",
    "search": "Search",
    "enable": "Enable",
    "disable": "Disable",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "confirm": "Confirm",
    "showMore": "Show more",
    "showLess": "Show less",
    "deleteTitle": "Do you really want to delete the item?",
    "deleteGroupTitle": "Do you really want to delete items?",
    "dependingElements": "Depending elements:",
    "successSaveMsg": "Saved",
    "successUpdateMsg": "Updated",
    "successDeleteMsg": "Deleted",
    "successDoneMsg": "Done",
    "successStartMsg": "Started",
    "userUpdate": "The user has been successfully updated",
    "editExpand": "Edit in a separate window",
    "format": "format",
    "deleteDepends": "Remove the element's dependencies",
    "downloadExcelFile": "Download Excel file",
    "yes": "Yes",
    "no": "No",
    "areMissing": "are missing",
    "yamlErrorMsg": "Incorrect YAML format",
    "relatedTabs": "Number of related tabs",
    "addToComparison": "Add to comparison",
    "addedToComparison": "Added",
    "removeFromComparison": "Remove from comparison",
    "compare": "Compare",
    "continue": "Continue",
    "cleanUpComparison": "Clear comparison history",
    "fullscreen": "fullscreen",
    "replace": "Replace",
    "blockUser": "Block user",
    "block": "Block",
    "unblockUser": "Unblock user",
    "toUpdate": "Update",
    "showSelected": "Show selected",
    "test": "Test",
    "center": "Center"
  },
  "placeholders": {
    "search": "Search",
    "date": "Select date",
    "dateRange": "Select dates",
    "select": "Select",
    "input": "Enter value",
    "newTag": "Press Enter to create a new tag"
  },
  "text": {
    "elementsCount": "Elements count",
    "more": "more {{count}}",
    "success": "Success",
    "error": "Error",
    "view": "View",
    "actions": "Actions",
    "copied": "Copied",
    "all": "All",
    "search": "Search",
    "selected": "Selected",
    "total": "Total",
    "inDevelopment": "In development...",
    "notSet": "Not set",
    "noData": "No data",
    "noResults": "No results found",
    "noResultsDescription": "We couldn't find anything matching your search. Try adjusting your filters or searching with different keywords to see more results.",
    "active": "Active",
    "inactive": "Inactive",
    "blockedUser": "Blocked",
    "activeUser": "Active",
    "expired": "Expired",
    "name": "Name",
    "value": "Value",
    "readonly": "Read only",
    "newElement": "New Element",
    "selectItem": "Select configuration item",
    "description": "Description",
    "nothingFound": "Nothing found",
    "today": "Today",
    "further": "Go further",
    "later": "Later",
    "loading": "Loading...",
    "noAvailableActions": "No available actions",
    "menu": "Menu",
    "settings": "Settings",
    "found": "Found",
    "hidden": "Hidden",
    "position": {
      "title": "Position",
      "top": "Top",
      "bottom": "Bottom",
      "left": "Left",
      "right": "Right"
    },
    "interval": {
      "customPlaceholder": "Enter interval: 30s",
      "off": "Off",
      "title": "Refresh rate",
      "seconds": {
        "one": "Every second",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "minutes": {
        "one": "Every minute",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "hours": {
        "one": "Every hour",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "days": {
        "one": "Every day",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "weeks": {
        "one": "Every week",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "months": {
        "one": "Every month",
        "few": "Every",
        "many": "Every",
        "other": "Every"
      },
      "null": {
        "other": "Unselected"
      }
    },
    "range": {
      "filterTitle": "Filter time range",
      "clockTime": "Time",
      "invalidDateTime": "Check the local date and time. End must not be before start.",
      "absoluteDate": "Absolute date",
      "customPlaceholder": "Enter duration: 2h, 4d",
      "title": "Range",
      "absolute": "Absolute range",
      "relative": "Relative range",
      "to": "To",
      "from": "From",
      "startTime": "Start time",
      "endTime": "End time",
      "ago": "ago",
      "now": "Now",
      "empty": "Select range",
      "last": {
        "seconds": {
          "one": "Last second",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        },
        "minutes": {
          "one": "Last minute",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        },
        "hours": {
          "one": "Last hour",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        },
        "days": {
          "one": "Last day",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        },
        "weeks": {
          "one": "Last week",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        },
        "months": {
          "one": "Last month",
          "few": "Last",
          "many": "Last",
          "other": "Last"
        }
      }
    }
  },
  "app": {
    "name": "PAMIR",
    "version": "Version",
    "versions": "Service versions",
    "appSettings": "App settings",
    "applicationError": {
      "oops": "Oops...",
      "somethingWentWrong": "Something went wrong",
      "alreadyReported": "This issue has just been reported. We will investigate it. Thank you for your patience. We appreciate your feedback.",
      "reloadPage": "Reload page"
    },
    "storagePrefetch": {
      "loading": "Loading application",
      "errorTitle": "Could not load the application",
      "errorDescription": "We could not get all required data. Retry loading to continue.",
      "reloadPage": "Reload page"
    },
    "backendUnavailable": {
      "title": "Service temporarily unavailable",
      "description": "The application cannot reach the API. It will reload automatically when the required services are available again.",
      "checking": "Checking connection… attempt {{count}}",
      "recovered": "Connection restored",
      "recoveredDescription": "The required services are responding again. The application will reload automatically.",
      "recoveredManualDescription": "The required services are responding again. Automatic reload is temporarily disabled to prevent a reload loop.",
      "reloadingIn": "Reloading in {{count}} s",
      "reloadManually": "The application can now be reloaded safely",
      "reloadNow": "Reload now"
    },
    "themeSettings": {
      "title": "Theme settings",
      "elements": "Visual elements settings",
      "lightTheme": "Light theme",
      "darkTheme": "Dark theme",
      "systemTheme": "System theme"
    }
  },
  "citFilter": {
    "clone": "Clone node",
    "delete": "Delete node"
  },
  "error": {
    "401": "Ошибка авторизации",
    "403": "Forbidden",
    "404": "Not found",
    "500": "Internal Server Error",
    "default": "Something went wrong",
    "connectionBreak": "Connection break"
  },
  "universalModal": {
    "monacoDialogTitle": "Edit template"
  },
  "ExpressionsValue": {
    "best": "Best",
    "worst": "Worst",
    "average": "Average",
    "percentile": "Percentile",
    "frequency": "Frequency"
  },
  "table": {
    "pagination": {
      "showTotal": "Items count : {{total}}"
    },
    "selected": "Selected: {{selected}}",
    "selectOdd": "Select odd",
    "selectEven": "Select even"
  },
  "conflictMessage": {
    "relatedCis": "CIs, related to a link:",
    "relatedLinks": "Number of related links:"
  },
  "sort": {
    "asc": "Ascend",
    "desc": "Descend"
  },
  "colorPicker": {
    "label": "default",
    "pickFromScreen": "Pick a color from the screen"
  },
  "versions": {
    "frontendVersion": "Frontend:",
    "backendVersion": "Backend:"
  },
  "datetime": {
    "year": "y",
    "month": "mo.",
    "day": "d",
    "hour": "h",
    "minute": "min.",
    "second": "s",
    "millisecond": "ms"
  },
  "theme": {
    "defaultRadius": "Radius",
    "defaultPrimaryColor": "Primary color",
    "defaultPrimaryShade": "Primary shade"
  },
  "appUpdate": {
    "updateAvailable": "App needs to be updated",
    "check": "Check for updates",
    "noUpdates": "No updates available",
    "notRegistered": "App update service is not registered",
    "offline": "You are offline",
    "unavailable": "Update service is unavailable",
    "checkFailed": "Failed to check for updates",
    "checking": "Checking for updates...",
    "downloading": "Downloading update",
    "preparing": "Preparing update",
    "reloading": "Updating...",
    "resetting": "Repairing update cache...",
    "resetFailed": "Failed to reset the update cache",
    "files": "{{count}} files"
  },
  "time": {
    "seconds": "{{count}} second",
    "seconds_plural": "{{count}} seconds",
    "seconds_many": "{{count}} seconds",
    "minutes": "{{count}} minute",
    "minutes_plural": "{{count}} minutes",
    "minutes_many": "{{count}} minutes",
    "hours": "{{count}} hour",
    "hours_plural": "{{count}} hours",
    "hours_many": "{{count}} hours",
    "days": "{{count}} day",
    "days_plural": "{{count}} days",
    "days_many": "{{count}} days",
    "weeks": "{{count}} week",
    "weeks_plural": "{{count}} weeks",
    "weeks_many": "{{count}} weeks",
    "months": "{{count}} month",
    "months_plural": "{{count}} months",
    "months_many": "{{count}} months"
  },
  "tableSelectors": {
    "selectAll": "Select all",
    "selectOdd": "Select odd",
    "selectEven": "Select even",
    "invert": "Invert selection",
    "unselect": "Clear selection"
  },
  "graphRenderer": {
    "export": {
      "viewport": "Export viewport",
      "graph": "Export graph",
      "json": "Export JSON"
    },
    "action": {
      "recenter": "Recenter"
    }
  }
}